export default {
  title: 'Usuń dane wartości zadań',
  confirmDelete: {
    header: 'Potwierdź usunięcie danych',
    message: 'Potwierdź, że chcesz Usunąć wartości elementu \'{item}\' pomiędzy {from} i {to}.',
  },
};
